module.exports = __webpack_public_path__ + "08_mole.5475acd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer2/08_mole.png
// module id = aLpO
// module chunks = 0